import { Link } from 'react-router-dom';
import { waLink } from '../lib/contact';

const CATERING_MSG = 'Hola Bar Cabrero. Estoy organizando un evento y querria info sobre catering de gildas. Gracias!';
const WA_CATERING = waLink(CATERING_MSG);

export default function TakeawayCatering({ variant = 'full' }) {
  if (variant === 'banner') {
    return (
      <section className="tc-banner" data-testid="takeaway-banner">
        <div className="tc-banner-inner">
          <div>
            <p className="eyebrow rv">Para llevar y eventos</p>
            <h2 className="D D-md rv" style={{ marginBottom: '0.5rem' }}>
              Llévate la gilda <em>a casa.</em>
            </h2>
            <p className="copy rv" style={{ maxWidth: '36rem' }}>
              Bandejas para llevar y catering para tus eventos. Bodas, cumpleaños, aperitivos de oficina. Avísanos con un par de días.
            </p>
          </div>
          <div className="tc-actions rv">
            <Link className="btn btn-g" to="/pedido" data-testid="tc-banner-takeaway">
              Configurar mi bandeja
            </Link>
            <a className="btn btn-o" href={WA_CATERING} target="_blank" rel="noopener noreferrer" data-testid="tc-banner-catering">
              Catering eventos
            </a>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className="sec sec-verde tc-full" data-testid="takeaway-section">
      <div className="split col2">
        <div>
          <p className="eyebrow rv" style={{ color: 'rgba(255,255,255,0.65)' }}>Para llevar y caterings</p>
          <h2 className="D D-lg rv" style={{ color: '#fff', marginBottom: '1rem' }}>
            Gildas <em style={{ color: 'rgba(255,255,255,0.85)' }}>para llevar.</em><br />Caterings <em style={{ color: 'rgba(255,255,255,0.85)' }}>para tus eventos.</em>
          </h2>
          <p className="rv" style={{ color: 'rgba(255,255,255,0.82)', lineHeight: 1.85, fontSize: '1rem', maxWidth: '36rem', marginBottom: '1.25rem' }}>
            ¿Te llevas una bandeja para una cena en casa? Te la preparamos con antelación. ¿Estás organizando una boda, un cumpleaños o un aperitivo de oficina? Hacemos catering de gildas, canapés y tortilla.
          </p>
          <p className="rv" style={{ color: 'rgba(255,255,255,0.65)', fontSize: '0.9rem', fontStyle: 'italic', marginBottom: '1.5rem' }}>
            Avísanos con un par de días. Cuanto más, mejor.
          </p>
          <div className="rv" style={{ display: 'flex', gap: '0.85rem', flexWrap: 'wrap' }}>
            <Link className="btn btn-w" to="/pedido" data-testid="tc-takeaway">
              Configurar mi bandeja
            </Link>
            <a className="btn btn-w" href={WA_CATERING} target="_blank" rel="noopener noreferrer" data-testid="tc-catering">
              Catering para mi evento
            </a>
          </div>
        </div>
        <div className="rv tc-pillars">
          <div className="tc-pillar">
            <div className="tc-pillar-n">2 días</div>
            <p>Antelación recomendada</p>
          </div>
          <div className="tc-pillar">
            <div className="tc-pillar-n">12</div>
            <p>Variedades a elegir</p>
          </div>
          <div className="tc-pillar">
            <div className="tc-pillar-n">∞</div>
            <p>Personas en tu evento</p>
          </div>
          <div className="tc-pillar">
            <div className="tc-pillar-n">A mano</div>
            <p>Cada gilda, una a una</p>
          </div>
        </div>
      </div>
    </section>
  );
}
